import { IMapState } from '../../types';

export function selectIsDropdownOpen(state: IMapState): boolean {
  return state.map.infrastructure.isDropdownOpen;
}
